// extracted by mini-css-extract-plugin
export default {"codeBlock":"CodeRender_codeBlock__4+v5M"};